export default "__VITE_ASSET__D4lp6aDr__"